import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import CommissionPaymentForm from './forms/CommissionPaymentForm';
import CommissionPaymentList from './lists/CommissionPaymentList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Invoice from "./OperationList/Elements/Invoice";
import get from "../../utils/get";
import Payment from "./OperationList/Elements/Payment";
import ModalEditor from "./ModalEditor";
import InvoiceEditor from "./invoiceEditor";
import connect from "react-redux/es/connect/connect";
import PrintButton from "../form/PrintButton";

class CommissionPaymentEditor extends React.Component {

    state = {
        finalizePayment: false
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        const res = await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    finalizePayment = async () => {
        if (this.state.finalizePayment === false) {
            this.setState({finalizePayment: {}});
            return false;
        }
        const values = await referenceActionData(this.props.values, this.props.componentConfig);
        delete values.items;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.finalizePayment',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
                this.setState({finalizePayment: false});
            }
            return response;
        });
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || parseInt(this.props.values.state || "0") > 0;
        return props;
    }

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Terjesztői megállapodások"
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <CommissionPaymentList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                        filter={[{field: "business_service_provider", value: this.props.pos.partner.partner_id}]}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Terjesztői megállapodás"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="2"
                            disabled={!(this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.state || "0") < 1) || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>,
                        <Fragment key="1">
                            <Modal
                                state={this.state.finalizePayment instanceof Object ? "on" : "off"}
                                theme="default"
                                size="large"
                                header="Biztos mehet?"
                                buttons={[
                                    {
                                        text: 'Mégse',
                                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                        onClose: true,
                                        onClick: async () => {
                                            try {
                                                this.setState({finalizePayment: false});
                                            } catch (e) {

                                            }
                                        }
                                    },
                                    {
                                        text: 'Mehet',
                                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                        onClick: async () => {
                                            await this.finalizePayment();
                                        }
                                    }
                                ]}
                            >
                                <Invoice
                                    props={{
                                        values: {...this.props.values, seller: this.props.values.business_service_provider, customer: this.props.values.commissioner},
                                        getProps: (name) => {return this.getProps("invoice." + name);},
                                        getValue: (name) => {if(name === "invoice.comment") name = "comment"; return this.getValue("invoice." + name);},
                                        setFieldValue: (field, value) => {if(field === "invoice.comment") field = "comment"; this.props.setFieldValue("invoice." + field, value);}
                                    }}
                                    default="seller"
                                />
                                <div className="row">
                                    <Payment props={{values: this.props.values, getFieldProps: this.getProps, getProps: this.getProps, getValue: this.getValue, setFieldValue: this.props.setFieldValue}} />
                                </div>
                            </Modal>
                            <Button
                                disabled={this.props.isLoading || !this.props.values[this.props.componentConfig.idfield] || this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.state || "0") > 0}
                                color="primary"
                                className="pull-right"
                                onClick={this.finalizePayment}
                            >
                                Véglegesítés
                            </Button>
                        </Fragment>,
                        (this.props.values.commission || {}).provider === "PackagePickup" && <PrintButton
                            {...this.props}
                            type="pdf"
                            values={this.props.values}
                            icon={{lib: "fas", name: "download"}}
                            color="default"
                            disabled={this.props.isLoading/* || parseInt(this.props.values.state || "0") === 0*/}
                        >
                            Riport letöltése
                        </PrintButton>
                    ]}
                >
                    <CommissionPaymentForm
                        {...this.props}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
                {this.props.values[this.props.componentConfig.idfield] && <Other>
                    <InvoiceEditor
                        editorContext="purchaseInvoiceEditor"
                        gridid="purchaseInvoiceList"
                        pageSize={0}
                        listFilter={[
                            {
                                field: "component",
                                value: this.props.componentConfig.componentname
                            },{
                                field: "component_id",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                        editor={ModalEditor}
                        selection={null}
                        onProcessAction={() => {
                            if (!this.props.isLoading) {
                                this.props.reloadForm && this.props.reloadForm();
                            }
                        }}
                    />
                </Other>}
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
        till: state.app.till,
        user: state.app.user
    };
})(createEditor({
    componentName: "CommissionPayment",
    WrappedComponent: CommissionPaymentEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            delete data.items;
            return {action, data, params};
        }
    }
}));
